import { useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Polls professional (human) replies while a conversation is in human handoff.
export const useHumanReplies = (sessionId, active, onMessages, onStatus) => {
  const lastRef = useRef(null);

  useEffect(() => {
    lastRef.current = new Date().toISOString();
  }, [sessionId]);

  useEffect(() => {
    if (!active) return undefined;
    const tick = async () => {
      try {
        const res = await axios.get(`${API}/chat/${sessionId}/messages`, {
          params: { after: lastRef.current },
        });
        const msgs = res.data.messages || [];
        if (msgs.length) {
          lastRef.current = msgs[msgs.length - 1].created_at;
          onMessages(msgs.map((m) => ({ role: "human", content: m.content })));
        }
        onStatus(res.data.handoff_active);
      } catch {
        /* keep polling */
      }
    };
    const id = setInterval(tick, 5000);
    return () => clearInterval(id);
  }, [sessionId, active, onMessages, onStatus]);
};
